if (!customElements.get('related-slider-progress')) {
  customElements.define(
    'related-slider-progress',
    class RelatedSliderProgress extends HTMLElement {
      constructor() {
        super();

        this.update = this.update.bind(this);
        this.requestUpdate = this.requestUpdate.bind(this);
        this.rafId = null;
      }

      connectedCallback() {
        this.slider = this.closest('grid-slider')?.querySelector('[data-grid-slider]') || this.previousElementSibling;

        if (!this.slider) return;

        this.track = this.querySelector('[data-slider-progress-track]');
        this.thumb = this.querySelector('[data-slider-progress-thumb]');
        this.buttonPrev = this.querySelector('[data-slider-progress-prev]');
        this.buttonNext = this.querySelector('[data-slider-progress-next]');

        this.slider.addEventListener('scroll', this.requestUpdate, {passive: true});
        this.slider.addEventListener('theme:grid-slider:init', this.requestUpdate);
        window.addEventListener('resize', this.requestUpdate);

        this.buttonPrev?.addEventListener('click', () => this.goToStep(-1));
        this.buttonNext?.addEventListener('click', () => this.goToStep(1));

        this.track?.addEventListener('click', (event) => {
          const rect = this.track.getBoundingClientRect();
          const maxScroll = this.slider.scrollWidth - this.slider.clientWidth;
          const ratio = Math.min(1, Math.max(0, (event.clientX - rect.left) / rect.width));

          this.slider.scrollTo({left: ratio * maxScroll, behavior: 'smooth'});
        });

        // Items arrive asynchronously and images change the scroll width once decoded
        this.mutationObserver = new MutationObserver(this.requestUpdate);
        this.mutationObserver.observe(this.slider, {childList: true, subtree: true});

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(this.requestUpdate);
          this.resizeObserver.observe(this.slider);
        }

        this.update();
      }

      disconnectedCallback() {
        this.slider?.removeEventListener('scroll', this.requestUpdate);
        this.slider?.removeEventListener('theme:grid-slider:init', this.requestUpdate);
        window.removeEventListener('resize', this.requestUpdate);
        this.mutationObserver?.disconnect();
        this.resizeObserver?.disconnect();
        if (this.rafId) cancelAnimationFrame(this.rafId);
      }

      requestUpdate() {
        if (this.rafId) cancelAnimationFrame(this.rafId);
        this.rafId = requestAnimationFrame(this.update);
      }

      goToStep(direction) {
        const item = this.slider.querySelector('[data-grid-item]');
        const step = item ? item.getBoundingClientRect().width : this.slider.clientWidth;

        this.slider.scrollTo({
          left: this.slider.scrollLeft + step * direction,
          behavior: 'smooth',
        });
      }

      update() {
        this.rafId = null;

        if (!this.slider || !this.thumb) return;

        const maxScroll = this.slider.scrollWidth - this.slider.clientWidth;
        const isScrollable = maxScroll > 1;

        this.classList.toggle('hidden', !isScrollable);

        if (!isScrollable) return;

        const scrollLeft = Math.min(maxScroll, Math.max(0, this.slider.scrollLeft));
        const scrollRatio = scrollLeft / maxScroll;
        const thumbWidth = Math.max(10, Math.min(100, (this.slider.clientWidth / this.slider.scrollWidth) * 100));

        this.thumb.style.width = `${thumbWidth}%`;
        this.thumb.style.left = `${(100 - thumbWidth) * scrollRatio}%`;

        const edgeGap = parseFloat(getComputedStyle(this.slider).scrollPaddingRight) || 0;

        if (this.buttonPrev) this.buttonPrev.disabled = scrollLeft <= 1;
        if (this.buttonNext) this.buttonNext.disabled = scrollLeft >= maxScroll - edgeGap - 1;
      }
    }
  );
}
